import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { DEFAULT_LINE_HEIGHT, EM_TO_PX_RATIO } from "./constants";
export var getContentHeight = function getContentHeight(lineHeight, fontSize) {
  var contentHeight;

  var _lineHeight = lineHeight ? Number(Array.isArray(lineHeight) ? lineHeight[0] : lineHeight) : DEFAULT_LINE_HEIGHT;

  if (typeof fontSize === 'string') {
    // extracting number and units from fontSize value
    var _fontSize$split = fontSize.split(/^(\d+(?:\.\d+)?)(.*)$/),
        _fontSize$split2 = _slicedToArray(_fontSize$split, 3),
        fontSizeValue = _fontSize$split2[1],
        fontSizeUnit = _fontSize$split2[2];

    contentHeight = _lineHeight * Number(fontSizeValue);

    if (/^r?em$/.test(fontSizeUnit)) {
      contentHeight *= EM_TO_PX_RATIO;
    }
  } else {
    contentHeight = _lineHeight * Number(Array.isArray(fontSize) ? fontSize[0] : fontSize);
  }

  return contentHeight;
};
export var getValueOrNull = function getValueOrNull(object, key) {
  if (object && object.hasOwnProperty(key) && object[key].length > 0) {
    return object[key];
  }

  return null;
};